import Vue from 'vue';
import { DateTime } from 'luxon';
import { OPERATION_URL, DATESASSIGMENTS_URL } from '@/features/operation/service';
import Service from './service';
import router from '../../router';

const CLEAR_MODULE = 'CLEAR_MODULE';
const UPDATE_ERROR = 'UPDATE_ERROR';
const UPDATE_SEARCHING_NOMBRE = 'UPDATE_SEARCHING_NOMBRE';
const UPDATE_IS_BUSY = 'UPDATE_IS_BUSY';
const UDPATE_OPERACION = 'UDPATE_OPERACION';

const searchNombreAction = 'searchNombreAction';
const submitAltaOperacionAction = 'submitAltaOperacionAction';
const clearErrorOperacionAction = 'clearErrorOperacionAction';
const clearModuleOperacionAction = 'clearModuleOperacionAction';

export default {
  namespaced: true,
  state: {
    error: '',
    isSearchingNombre: false,
    isBusy: false,
    operation: {
      id: 'dummy',
      nombre: '',
      fechaEntrada: null,
    },
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'error', '');
      Vue.set(state, 'isSearchingNombre', false);
      Vue.set(state, 'isBusy', false);
      Vue.set(state, 'operation', { id: 'dummy', nombre: '', fechaEntrada: null });
      Vue.set(state.operation, 'nombre', '');
      Vue.set(state.operation, 'fechaEntrada', '');
    },
    [UPDATE_ERROR](state, error) {
      state.error = error;
    },
    [UPDATE_SEARCHING_NOMBRE](state, searching) {
      state.isSearchingNombre = searching;
    },
    [UPDATE_IS_BUSY](state, busy) {
      state.isBusy = busy;
    },
    [UDPATE_OPERACION](state, payload) {
      Vue.set(state, 'operation', payload);
    },
  },
  actions: {
    [searchNombreAction]({ commit }, payload) {
      commit(UPDATE_ERROR, '');
      commit(UPDATE_SEARCHING_NOMBRE, true);
      return Service.exitsOperationName(payload)
        .then((val) => {
          commit(UPDATE_SEARCHING_NOMBRE, false);
          if (val.exists) {
            commit(UPDATE_ERROR, 'El nombre de operación ya existe');
          } else {
            commit(UDPATE_OPERACION, { nombre: payload, id: 'dummy' });
          }
        });
    },
    [submitAltaOperacionAction]({ commit, rootState, rootGetters, dispatch }, payload) {
      commit(UPDATE_IS_BUSY, true);
      const state = rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Análisis' });
      const op = {
        title: payload.nombre,
      };
      const fechaEntradaForm = DateTime.fromISO(payload.fechaEntrada).toISODate();
      const dates = { title: payload.nombre, fechaEntrada: fechaEntradaForm };
      const report = { title: `${payload.nombre}-r` };
      const preReport = { title: `${payload.nombre}-pr` };
      let preReportSaved = {};
      let reportSaved = {};
      let datesSaved = {};
      return dispatch('datesAssignements_model/upsertEntityAction', dates, { root: true })
        .then((res) => {
          datesSaved = res;
          dispatch('report_model/upsertEntityAction', report, { root: true })
            .then((reportResponse) => {
              reportSaved = reportResponse;
              dispatch('prereport_model/upsertEntityAction', preReport, { root: true })
                .then((preReportResponse) => {
                  preReportSaved = preReportResponse;
                  op.report = reportSaved.id;
                  op.prereport = preReportSaved.id;
                  op.datesAssigments = datesSaved.id;
                  op.state = state;
                  dispatch('operation_model/upsertEntityAction', op, { root: true })
                    .then(opSaved => router.push({ name: 'analisis', params: { opid: opSaved.uuid } }));
                });
            });
        })
        .catch((error) => {
          if (error.config && error.config.url === `${OPERATION_URL}`) {
            commit(UPDATE_ERROR, 'Error en el servicio, no se pudo crear la operación');
          } else if (error.config && error.config.url === `${DATESASSIGMENTS_URL}`) {
            commit(UPDATE_ERROR, 'Error en el servicio, no se pudo guardar la fecha');
          } else {
            // eslint-disable-next-line no-console
            commit(UPDATE_ERROR, 'Error en el servicio');
          }
          commit(UPDATE_IS_BUSY, false);
        });
    },
    [clearErrorOperacionAction]({ commit }) {
      commit(UPDATE_ERROR, '');
    },
    [clearModuleOperacionAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
  },
  getters: {
    newOperationState(state) {
      let opState = 0;
      if (state.operation.nombre !== '' && state.operation.id === 'dummy') {
        opState = 1;
      } else if (state.operation.id !== 'dummy') {
        opState = 2;
      }
      return opState;
    },
  },
};



// WEBPACK FOOTER //
// ./src/features/operation-new/store.js